export function patchHistory() {
  // Fix for browser history routing where each MFE has its own router and
  // internal routing state. This hack fakes a popstate event when a router calls
  // `pushState` or `replaceState` so that all routers are updated.
  const { pushState, replaceState } = history;

  history.pushState = function (...args) {
    pushState.call(this, ...args);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };
  history.replaceState = function (...args) {
    replaceState.call(this, ...args);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };
}
